import { render, staticRenderFns } from "./form-queries-list.vue?vue&type=template&id=45a19318&"
import script from "./form-queries-list.vue?vue&type=script&lang=js&"
export * from "./form-queries-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-queries-list.vue"
export default component.exports